import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Home() {
  const { t } = useTranslation();

  return (
    <div>
      <p className="font-mono text-xs tracking-[0.15em] uppercase border-t-[3px] border-slate-900 pt-2.5 mb-9 text-slate-900">
        {t('home.eyebrow')}
      </p>

      <h1 className="font-bold text-6xl sm:text-7xl leading-[0.92] tracking-tight lowercase mb-10 text-slate-900" style={{ textWrap: 'balance' }}>
        ndsworks
      </h1>

      <p className="font-bold text-2xl sm:text-3xl leading-tight mb-12 max-w-2xl text-slate-900">
        {t('home.manifesto')}{' '}
        <span className="underline decoration-[3px] underline-offset-4">{t('home.manifestoLast')}</span>
      </p>

      <div className="flex border-t-[3px] border-b-[3px] border-slate-900">
        <a
          href="https://wheel.ndsworks.com"
          className="flex-1 text-center font-mono text-sm tracking-[0.08em] uppercase py-5 px-3 hover:bg-slate-900 hover:text-white transition-colors"
        >
          {t('home.exploreWheelWithin')}
        </a>
        <Link
          to="/blog"
          className="flex-1 text-center font-mono text-sm tracking-[0.08em] uppercase py-5 px-3 border-l-[3px] border-slate-900 hover:bg-slate-900 hover:text-white transition-colors"
        >
          {t('home.readBlog')}
        </Link>
      </div>

      <p className="font-mono text-xs text-slate-600 max-w-lg mt-10">
        {t('home.nameOrigin')}
      </p>
    </div>
  );
}

export default Home;
